module.exports = __webpack_public_path__ + "static/media/Target.a1686615.svg";